import React from 'react';
import { Card, TemplateHeader, TemplateDesc, Tag, SmallMeta } from '../shared';

export interface EstimatedCostCardProps {
  productUrls: number;
  retailers?: number;
  frequency?: string;
}

const EstimatedCostCard: React.FC<EstimatedCostCardProps> = ({
  productUrls,
  retailers = 0,
  frequency = '-',
}) => {
  const toFrequencyFactor = (freq: string | undefined): number => {
    const s = (freq || '').toString().toLowerCase();
    if (s === 'daily') return 7;
    if (s === 'weekly') return 1;
    if (s === 'monthly') return 0.25;
    return 0;
  };

  const factor = toFrequencyFactor(frequency);
  const costPerWeekRaw = (Number(productUrls) || 0) * factor;
  const formatNumber = (n: number) => {
    if (!Number.isFinite(n)) return '—';
    const isWhole = Math.abs(n - Math.round(n)) < 1e-9;
    if (isWhole) {
      return Math.round(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return n.toLocaleString(undefined, { maximumFractionDigits: 2 });
  };
  const costPerWeekLabel = `$${formatNumber(costPerWeekRaw)} / week`;
  return (
    <Card style={{ minWidth: 320 }}>
      <TemplateHeader>Estimated Cost</TemplateHeader>
      <TemplateDesc style={{ fontWeight: 400, fontSize: 14, color: '#031425'}}>
        Credits are only consumed when the data is successfully returned.
      </TemplateDesc>

      <div style={{ fontWeight: 700, marginBottom: 12, fontSize: 14 }}>Inputs:</div>
      <div style={{ display: 'grid', rowGap: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Tag>Product URLs:</Tag>
          <div style={{ fontSize: 14, color: '#031425' }}>{productUrls}</div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Tag>Retailers:</Tag>
          <div style={{ fontSize: 14, color: '#031425' }}>{retailers}</div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Tag>Frequency:</Tag>
          <div style={{ fontSize: 14, color: '#031425' }}>{frequency ?? '-'}</div>
        </div>
      </div>

      <div style={{ borderTop: '1px solid #E6ECF2', margin: '16px 0' }} />

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <SmallMeta>Cost per week</SmallMeta>
        <div style={{ fontWeight: 700, color: '#031425' }}>{costPerWeekLabel}</div>
      </div>
    </Card>
  );
};

export default EstimatedCostCard;


